import { api, apiMind } from ".";
import * as Actions from "../redux/constants/Auth";
import { UPLOAD_ACCEPTED_MIME_TYPES, UPLOAD_MAX_BYTES } from "../constants/DocumentConstant";

const service = {};
const config = () => {
  return {
    headers: { Authorization: `${localStorage.getItem(Actions.AUTH_TOKEN)}` },
  };
};

const endpoint = "solicitations";

const EXPORT_BATCH_SIZE = 500;
const EXPORT_MAX_BATCHES = 200;

const collectAllPages = async function (fetchPage) {
  const rows = [];
  let meta = { totalItems: 0 };

  for (let page = 1; page <= EXPORT_MAX_BATCHES; page += 1) {
    const result = await fetchPage(page, EXPORT_BATCH_SIZE);

    if (!result || result.error) {
      return { data: rows, meta, error: true, type: result?.type, status: result?.status };
    }

    const batch = Array.isArray(result.data) ? result.data : [];
    rows.push(...batch);
    meta = result.meta ?? meta;

    const total = Number(meta?.totalItems);
    if (batch.length < EXPORT_BATCH_SIZE) break;
    if (Number.isFinite(total) && total > 0 && rows.length >= total) break;
  }

  return { data: rows, meta, error: false, status: 200 };
};

service.getAllSolicitations = async function () {
  let result = null;
  await api
    .get(`/api/${endpoint}`, config())
    .then((res) => {
      result = { data: res.data, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response.status,
      };
    });
  return result;
};

service.getAllSolicitationsDoc = async function (page, limit, currentSortItem, filterList) {
  let result = null;
  let url = "";
  let filterParams = "";
  if (filterList) {
    for (const key in filterList) {
      const value = filterList[key];
      if (value === undefined || value === null) continue;

      if (typeof value === "number") {
        if (value !== 0) filterParams += `&filter[${key}]=${value}`;
      } else if (String(value).length > 0) {
        filterParams += `&filter[${key}]=${value}`;
      }
    }
  }

  if (currentSortItem.field) {
    url = `/api/${endpoint}/all-ser/doc?page=${page}&limit=${limit}${filterParams}&sort[${currentSortItem.field}]=${currentSortItem.value}`;
  } else {
    url = `/api/${endpoint}/all-ser/doc?page=${page}&limit=${limit}${filterParams}`;
  }

  await api
    .get(`${url}`, config())
    .then((res) => {
      result = { ...res.data, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: [],
        meta: { totalItems: 0 },
        error: true,
        type: error,
        status: error.response?.status,
      };
    });
  return result;
};

service.getAllSolicitationsDocForExport = async function (currentSortItem, filterList) {
  return collectAllPages((page, limit) =>
    service.getAllSolicitationsDoc(page, limit, currentSortItem, filterList),
  );
};

service.getSolicitationReceitaFederal = async function (id) {
  let result = null;
  await api
    .get(`/api/${endpoint}/${id}/receita-federal`, config())
    .then((res) => {
      result = { data: res.data, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response.status,
      };
    });
  return result;
};

service.getSolicitationById = async function (id) {
  let result = null;
  await api
    .get(`/api/${endpoint}/${id}`, config())
    .then((res) => {
      result = { ...res.data, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response?.status,
      };
    });
  return result;
};

service.getSolicitationUserById = async function (id) {
  let result = null;
  await api
    .get(`/api/${endpoint}/user/${id}`, config())
    .then((res) => {
      result = { data: res.data, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response.status,
      };
    });
  return result;
};

service.getPendingSolicitations = async function () {
  let result = null;
  await api
    .get(`/api/${endpoint}/review`, config())
    .then((res) => {
      result = { data: res.data, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response.status,
      };
    });
  return result;
};

service.getPendingDocSolicitations = async function (page, limit, currentSortItem, filterList) {
  let result = null;
  let url = "";
  let filterParams = "";

  if (filterList) {
    for (const key in filterList) {
      const value = filterList[key];
      if (value === undefined || value === null) continue;

      if (typeof value === "number") {
        if (value !== 0) filterParams += `&filter[${key}]=${value}`;
      } else if (String(value).length > 0) {
        filterParams += `&filter[${key}]=${value}`;
      }
    }
  }

  if (currentSortItem.field) {
    url = `/api/${endpoint}/review-doc?page=${page}&limit=${limit}${filterParams}&sort[${currentSortItem.field}]=${currentSortItem.value}`;
  } else {
    url = `/api/${endpoint}/review-doc?page=${page}&limit=${limit}${filterParams}`;
  }

  await api
    .get(url, config())
    .then((res) => {
      result = { ...res.data, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response.status,
      };
    });
  return result;
};

service.getPendingDocSolicitationsForExport = async function (currentSortItem, filterList) {
  return collectAllPages((page, limit) =>
    service.getPendingDocSolicitations(page, limit, currentSortItem, filterList),
  );
};

service.getCompletedSolicitations = async function () {
  let result = null;
  await api
    .get(`/api/${endpoint}/complete`, config())
    .then((res) => {
      result = { data: res.data, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response.status,
      };
    });
  return result;
};

service.deleteSolicitation = async function (id) {
  let result = null;
  await api
    .delete(`/api/${endpoint}/${id}`, config())
    .then((res) => {
      result = { ...res.data, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response.status,
      };
    });
  return result;
};

service.exportSolicitations = async function (filters) {
  let result = null;
  await api
    .post(`/api/${endpoint}/export`, filters, config())
    .then((res) => {
      result = { data: res.data, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response.status,
      };
    });
  return result;
};

service.putDocumentApproved = async function (data) {
  let result = null;
  await api
    .put(`/api/documents/approve`, data, config())
    .then((res) => {
      result = { ...res.data, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response.status,
      };
    });
  return result;
};

service.putSolicitationStatusOnly = async function (data) {
  let result = null;
  await api
    .put(`/api/${endpoint}/status_only`, data, config())
    .then((res) => {
      result = { data: res.data.status, bndesSync: res.data.bndesSync, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response?.status,
      };
    });
  return result;
};

service.putSolicitationProjectOnly = async function (data) {
  let result = null;
  await api
    .put(`/api/${endpoint}/project_only`, data, config())
    .then((res) => {
      result = { data: res.data.status, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response.status,
      };
    });
  return result;
};

service.approveSolicitation = async function (data) {
  let result = null;
  await api
    .put(`/api/${endpoint}/status`, data, config())
    .then((res) => {
      result = { data: res.data.status, bndesSync: res.data.bndesSync, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response?.status,
      };
    });
  return result;
};

service.updateDocument = async function (body, id) {
  let result = null;
  const data = new FormData();

  const { file, type, solicitation_id, guarantor_id } = body;

  data.append("file", file);
  data.append("type", type);
  solicitation_id && data.append("solicitation_id", solicitation_id);
  guarantor_id && data.append("guarantor_id", guarantor_id);

  console.log(data, "guarantor", guarantor_id);
  await api
    .put(`/api/documents/update-document/${id}`, data, config())
    .then((res) => {
      result = { data: res.data, error: false, type: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response?.status ?? null,
      };
    });
  return result;
};

service.uploadDocument = async function ({ file, type, solicitation_id }) {
  let result = null;
  const data = new FormData();
  data.append("file", file);
  data.append("type", type);
  data.append("solicitation_id", solicitation_id);

  await api
    .post(`/api/documents/upload/`, data)
    .then((res) => {
      console.log("RES DOC ==> ", res);
      result = { data: res.data, error: false, type: res.status };
    })
    .catch((error) => {
      console.log("RES DOC ERROR ==> ");
      result = { data: null, error: true, type: error };
    });
  return result;
};

service.getSignedUrl = async function ({ fileName }) {
  let result = null;
  await api
    .get(`/api/v1/generate-signed-url/${fileName}`, config())
    .then((res) => {
      console.log("RES DOC ==> ", res);
      result = { data: res.data, error: false, type: res.status };
    })
    .catch((error) => {
      console.log("RES DOC ERROR ==> ");
      result = { data: null, error: true, type: error };
    });
  return result;
};

service.getCreditApplicationStatus = async function (id) {
  let result = null;
  await apiMind
    .get(`/api/v1/credit-applications/${id}/status`)
    .then((res) => {
      result = { data: res.data, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response?.status,
      };
    });
  return result;
};

service.getMpoSignatureStatus = async function (id) {
  let result = null;
  await apiMind
    .get(`/api/v1/credit-applications/${id}/mpo-signature-status`)
    .then((res) => {
      result = { data: res.data, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response?.status,
      };
    });
  return result;
};

service.reviewCreditApplicationDocument = async function (applicationId, documentId, action, reviewerNote) {
  let result = null;
  const payload = { action };
  if (reviewerNote) payload.reviewerNote = reviewerNote;

  await apiMind
    .post(`/api/v1/credit-applications/${applicationId}/documents/${documentId}/review`, payload)
    .then((res) => {
      result = { data: res.data, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response?.status,
      };
    });
  return result;
};

service.getCreditApplicationDocumentAccessUrl = async function (applicationId, documentId) {
  let result = null;
  await apiMind
    .get(`/api/v1/credit-applications/${applicationId}/documents/${documentId}/access-url`)
    .then((res) => {
      result = { data: res.data, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response?.status,
      };
    });
  return result;
};

service.uploadCreditApplicationDocument = async function (applicationId, stepKey, documentType, file) {
  const mimeType = file.type || "application/octet-stream";

  if (!UPLOAD_ACCEPTED_MIME_TYPES.includes(mimeType)) {
    return { data: null, error: true, message: "Formato não aceito. Envie JPG, PNG, WEBP ou PDF." };
  }
  if (file.size > UPLOAD_MAX_BYTES) {
    return { data: null, error: true, message: "Arquivo acima de 20MB. Envie uma versão menor." };
  }

  try {
    const signed = await apiMind.post(
      `/api/v1/credit-applications/${applicationId}/documents/upload-url`,
      { stepKey, documentType, filename: file.name, mimeType },
    );

    const upload = await apiMind.put(signed.data.uploadUrl, file, {
      headers: { "Content-Type": mimeType },
    });

    const completed = await apiMind.post(
      `/api/v1/credit-applications/${applicationId}/documents/${signed.data.documentId}/complete-upload`,
      { sizeBytes: upload.data?.sizeBytes ?? file.size, checksum: upload.data?.checksum },
    );

    return { data: completed.data, error: false, status: completed.status };
  } catch (error) {
    return {
      data: null,
      error: true,
      type: error,
      status: error.response?.status,
      message: error.response?.data?.message,
    };
  }
};

service.approveCreditApplicationStep = async function (id, stepKey, version, reviewerNote) {
  let result = null;
  const payload = { stepKey, version, approved: true };
  if (reviewerNote) payload.reviewerNote = reviewerNote;

  await apiMind
    .post(`/api/v1/credit-applications/${id}/approve-step`, payload)
    .then((res) => {
      result = { data: res.data, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response?.status,
        message: error.response?.data?.message,
      };
    });
  return result;
};

service.getSolicitationsByStatus = async function (solicitation_id, status) {
  let result = null;
  await api
    .get(`/api/v1/${endpoint}/cancelled-approved/${solicitation_id}/${status.toUpperCase()}`, config())
    .then((res) => {
      result = { data: res.data, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response.status,
      };
    });
  return result;
};

service.getFacematchByApplication = async function (applicationId) {
  let result = null;
  await apiMind
    .get(`/api/facematch/applications/${applicationId}`)
    .then((res) => {
      result = { data: res.data?.data ?? null, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response?.status,
      };
    });
  return result;
};

service.getBackgroundCheckByApplication = async function (applicationId) {
  let result = null;
  await apiMind
    .get(`/api/background-check/applications/${applicationId}`)
    .then((res) => {
      result = { data: res.data?.data ?? null, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response?.status,
      };
    });
  return result;
};

service.reprocessFacematch = async function (applicationId) {
  let result = null;
  await apiMind
    .post(`/api/facematch/applications/${applicationId}`)
    .then((res) => {
      result = { data: res.data?.data ?? null, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response?.status,
      };
    });
  return result;
};

service.reprocessBackgroundCheck = async function (applicationId) {
  let result = null;
  await apiMind
    .post(`/api/background-check/applications/${applicationId}`)
    .then((res) => {
      result = { data: res.data?.data ?? null, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response?.status,
      };
    });
  return result;
};

service.getIdfByApplication = async function (applicationId) {
  let result = null;
  await apiMind
    .get(`/api/idf/applications/${applicationId}`)
    .then((res) => {
      result = { data: res.data?.data ?? null, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response?.status,
      };
    });
  return result;
};

service.getSerasaUsage = async function () {
  let result = null;
  await apiMind
    .get(`/api/serasa/usage`)
    .then((res) => {
      result = { data: res.data?.data ?? null, error: false, status: res.status };
    })
    .catch((error) => {
      result = {
        data: null,
        error: true,
        type: error,
        status: error.response?.status,
      };
    });
  return result;
};

export default service;
